import { PointCardListPage } from './pointCard.list.page';

export default PointCardListPage;
